import { Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Features } from "src/components/featuresList";
import AccessDenied from "../toolbar.component/accessDenied";

const AppTabsComponent = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabs, setTabsData] = useState([]);
  const [activeTab, setActiveTab] = useState("0");
  const [isLoading, setIsLoading] = useState(true);
  const permissionsObj = useSelector(
    (state) => state.oidc?.user?.auth?.grantedPolicies
  );

  const names = Features?.find(
    (tab) => tab.serviceName?.toLowerCase() === props.serviceName?.toLowerCase()
  );

  const updateTabsWithPermissions = (menu, permissions) => {
    const lowerCasePermissions = Object.keys(permissions || {}).reduce(
      (acc, key) => {
        acc[key.toLowerCase()] = permissions[key];
        return acc;
      },
      {}
    );

    return (
      menu?.isTabs
        ?.filter((tab) => {
          const permissionKey = `${menu.serviceName}.${tab.Name}`.toLowerCase();
          return lowerCasePermissions[permissionKey];
        })
        .map((tab, index) => ({
          ...tab,
          key: tab.key || String(index + 1),
        })) || []
    );
  };

  useEffect(() => {
    if (props.staticmenuData) {
      setTabsData(props.staticmenuData?.isTabs);
      const initialTabKey = props.staticmenuData?.isTabs?.[0]?.key || "0";
      setActiveTab(initialTabKey);
      setIsLoading(false);
      props?.handleAccessDenied?.(!props.staticmenuData?.isTabs?.length)
    } else {
      if (names && permissionsObj) {
        const updatedTabs = updateTabsWithPermissions(names, permissionsObj);
        setTabsData(updatedTabs);
        const initialTabKey = updatedTabs[0]?.key || "0";
        setActiveTab(initialTabKey);
        props?.handleAccessDenied?.(updatedTabs.length === 0);
        if (!props.isNoRouting && updatedTabs[0]?.path && updatedTabs.length !== 0) {
          const dynamicPath = updatedTabs[0]?.path?.replace(":id", props?.gridId);
          navigate(dynamicPath);
        }
      }
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (tabs?.length > 0) {
      const matchingTab = tabs?.find((tab) => location.pathname.includes(tab.path));
      if (matchingTab) {
        setActiveTab(matchingTab.key);
      }
    }
  }, [location.pathname, tabs]);

  const handleTabChange = useCallback((key) => {
    setActiveTab(key);
    if (!props.isNoRouting && tabs.length !== 0) {
      const selectedTab = tabs.find((tab) => tab.key === key);
      if (selectedTab?.path) {
        const dynamicPath = selectedTab.path.replace(":id", props?.gridId);
        navigate(dynamicPath);
      }
    }
  }, [navigate, props?.gridId, props.isNoRouting, tabs]);

  if (isLoading) return null;
  return (
    <>
      {tabs && tabs.length !== 0 ? (
        <Tabs activeKey={activeTab} onChange={handleTabChange} tabPosition={props.tabPosition || ""}>
          {tabs?.map((tab) => {
            const TabComponent = props.tabComponents?.[tab.componentName];
            return (
              <Tabs.TabPane tab={tab.title} key={tab.key}>
                {TabComponent && props.isNoRouting && <TabComponent />}
              </Tabs.TabPane>
            );
          })}
        </Tabs>
      ) : (
        <AccessDenied />
      )}
    </>
  );
};

export default AppTabsComponent;
